import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { LoggerService } from 'src/app/logger.service';
import firebase from 'firebase/compat/app';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {
  constructor(
    public auth: AngularFireAuth,
    private logger: LoggerService,
    private snackBar: MatSnackBar,
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIconLiteral(
      'google',
      this.sanitizer.bypassSecurityTrustHtml(`
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill="#EA4335" d="M12 11.2v3.9h5.5c-.2 1.3-1.5 3.9-5.5 3.9-3.3 0-6-2.7-6-6s2.7-6 6-6c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.8 4.5 14.6 3.6 12 3.6 7.4 3.6 3.6 7.4 3.6 12S7.4 20.4 12 20.4c6.9 0 8.4-6.4 7.8-9.2H12z"/>
          <path fill="#4285F4" d="M20.4 12.2c0-.6-.1-1.1-.2-1.6H12v3.1h4.7c-.2 1-.8 2-1.7 2.6l2.7 2.1c1.6-1.5 2.7-3.7 2.7-6.2z"/>
          <path fill="#FBBC05" d="M6.9 14.3c-.2-.5-.3-1-.3-1.5s.1-1 .3-1.5l-2.8-2.2c-.6 1.1-.9 2.4-.9 3.7s.3 2.6.9 3.7l2.8-2.2z"/>
          <path fill="#34A853" d="M12 20.4c2.6 0 4.8-.9 6.4-2.4l-2.7-2.1c-.8.5-1.8.8-3.7.8-2.8 0-5.2-1.9-6-4.5L3.2 14.4c1.5 3.5 4.9 6 8.8 6z"/>
        </svg>
      `)
    );
  }

  ngOnInit(): void {}

  async login() {
    try {
      await this.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
    } catch (error: any) {
      this.logger.error(error);
      const message =
        error?.message ||
        '登录失败，请检查浏览器弹窗拦截或 Firebase Authorized domains 配置。';
      this.snackBar.open(message, '关闭', { duration: 5000 });
    }
  }

  sendAuthEmail(email: string) {
    this.auth
      .sendSignInLinkToEmail(email, {
        url: 'http://localhost:3000/login',
        // This must be true.
        handleCodeInApp: true,
      })
      .then(() => {
        window.localStorage.setItem('emailForSignIn', email);
      });
  }

  loginWithEmailLink() {
    if (!this.auth.isSignInWithEmailLink(window.location.href)) return;

    let email = window.localStorage.getItem('emailForSignIn');
    if (!email) {
      email = window.prompt('Please provide your email for confirmation');
    }
    this.auth
      .signInWithEmailLink(email!, window.location.href)
      .then((res) => {
        this.logger.log(res);
        window.localStorage.removeItem('emailForSignIn');
      })
      .catch((error) => {
        this.logger.error(error);
      });
  }

  logout() {
    this.auth.signOut();
  }
}
